<div class="button-container">
  <oui-button
    class="fiche-consultant-documents-add-btn"
    [class.dragover]="isDragOver"
    type="icon"
    (click)="onAddDocumentClick()"
    (drop)="onDocumentDrop($event)"
    (dragover)="onDocumentDragOver($event)"
    (dragleave)="onDragLeave($event)">
    <div class="fiche-consultant-documents-add-btn-body">
      <span class="text-highlight">Selectionnez</span>
      <span class="text-low-font-size">&nbsp;ou glissez un document</span>
    </div>
  </oui-button>
  <span class="button-separator">- ou -</span>
  <oui-button
    class="fiche-consultant-documents-add-btn"
    [class.dragover]="isDragOver"
    type="icon"
    (click)="setDisplayDemandePjPanel.emit()">
    <div class="fiche-consultant-documents-add-btn-body">
      <span class="text-low-font-size">Faire une &nbsp;</span>
      <span class="text-highlight">demande de documents</span>
    </div>
  </oui-button>
</div>

@if (isLoading()) {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
} @else {
  <div class="table">
    <oui-table class="table__header">
      <table mat-table>
        <ng-container matColumnDef="nom">
          <th mat-header-cell *matHeaderCellDef>Nom</th>
        </ng-container>
        <ng-container matColumnDef="type">
          <th
            class="header-right"
            mat-header-cell
            *matHeaderCellDef
            style="text-align: center">
            Type
          </th>
        </ng-container>
        <ng-container matColumnDef="dateDepot">
          <th
            class="header-right"
            mat-header-cell
            *matHeaderCellDef
            style="text-align: center">
            Dépôt
          </th>
        </ng-container>
        <ng-container matColumnDef="dateExpiration">
          <th
            class="header-right"
            mat-header-cell
            *matHeaderCellDef
            style="text-align: center">
            Expiration
          </th>
        </ng-container>
        <ng-container matColumnDef="statut">
          <th
            class="header-right"
            mat-header-cell
            *matHeaderCellDef
            style="text-align: center">
            Statut
          </th>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      </table>
    </oui-table>

    @for (groupedDocument of groupedDocuments(); track groupedDocument) {
      @let dataSource = groupedDocument.documents;
      <div class="table__categorie-title subtitle-1">
        {{ groupedDocument.sectionDocument }}
      </div>
      <oui-table class="table__group">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="nom">
            <td mat-cell *matCellDef="let element">
              <div class="icon-container">
                <oui-icon
                  [class]="element.isPrive ? 'icon-color-prive' : 'icon-color-public'"
                  >article</oui-icon
                >
                <span style="word-break: break-all">{{ element.fileName }}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <td
              class="content-right"
              mat-cell
              *matCellDef="let element"
              style="text-align: center">
              @if (element.typeDocument !== 'autre') {
                <span>{{ element.documentName }}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="dateDepot">
            <td
              class="content-right"
              mat-cell
              *matCellDef="let element"
              style="text-align: center">
              {{ element.date | date: 'dd/MM/yyyy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dateExpiration">
            <td
              class="content-right"
              mat-cell
              *matCellDef="let element"
              style="text-align: center">
              {{ element.expirationTime | date: 'dd/MM/yyyy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="statut">
            <td mat-cell *matCellDef="let element">
              <div class="statut-container">
                <app-status-tag
                  [status]="element.statut"
                  [demandeType]="'validationPj'"></app-status-tag>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <td mat-cell *matCellDef="let element" style="text-overflow: unset">
              <oui-menu [menuItems]="actionMenu()" horizontalPosition="left">
                <oui-button
                  type="icon"
                  color="secondary"
                  (click)="
                    selectedSection.set(groupedDocument.sectionDocument);
                    selectedDocName.set(element.documentName);
                    selectedDocType.set(element.typeDocument);
                    selectedDocId.set(element.id)
                  "
                  ><oui-icon>more_vert</oui-icon></oui-button
                >
              </oui-menu>
            </td>
          </ng-container>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="interactive"
            (click)="openDocument(row)"></tr>
        </table>
      </oui-table>
    }
  </div>
}

<input
  #fileInput
  type="file"
  (change)="onFileInputChange($event)"
  style="display: none" />
